import React, { useState } from 'react';
import { TextField, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { formFieldStyles } from './FormField.styles';

const TextInputField = ({
  field,
  value,
  onChange,
  onBlur,
  error,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = event => {
    if (onChange) {
      onChange(field.name, event.target.value, event);
    }
  };

  const handleBlur = event => {
    if (onBlur) {
      onBlur(field.name, value, event);
    }
  };

  const handleTogglePassword = () => {
    setShowPassword(prev => !prev);
  };

  const getInputProps = () => {
    if (field.type === 'password') {
      return {
        ...field.InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={handleTogglePassword}
              edge="end"
              size="small"
              disabled={disabled}
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      };
    }
    return field.InputProps;
  };

  const baseProps = {
    disabled,
    error: !!error,
    fullWidth: true,
    sx: formFieldStyles.field,
    type:
      field.type === 'password'
        ? showPassword
          ? 'text'
          : 'password'
        : field.type,
    label: field.label ? t(field.label) : '',
    placeholder: field.placeholder ? t(field.placeholder) : '',
    value: value || '',
    onChange: handleChange,
    onBlur: handleBlur,
    autoFocus: field.autoFocus,
    autoComplete: field.autoComplete,
    helperText: error,
    inputProps: {
      ...field.inputProps,
      maxLength: field.maxLength,
    },
    InputProps: getInputProps(),
  };

  if (field.type === 'textarea') {
    const multilineProps = field.rows
      ? { rows: field.rows }
      : {
          minRows: field.minRows || 3,
          maxRows: field.maxRows || 6,
        };

    return (
      <TextField {...baseProps} multiline {...multilineProps} type="text" />
    );
  }

  if (field.multiline) {
    const multilineProps = field.rows
      ? { rows: field.rows }
      : {
          minRows: field.minRows || 2,
          maxRows: field.maxRows || 4,
        };

    return <TextField {...baseProps} multiline {...multilineProps} />;
  }

  return <TextField {...baseProps} />;
};

export default TextInputField;
